export const getMyPoints = state => state.my_points
export const getMyPointSum = state => state.my_pointsum
export const getMyEarnedPointSum = state => state.my_earned_pointsum
export const getMySpentPointSum = state => state.my_spent_pointsum
